import { configureOidc } from '@/services/auth.service';
import Axios from 'axios';
export default async (): Promise<void> => {
  const auth = await configureOidc();
  Axios.defaults.headers.common['Authorization'] = 'Bearer ' + auth.accessToken;
};
